import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '../../lib/cn';

interface ContainerProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  size?: 'default' | 'narrow' | 'wide';
}

export function Container({
  children,
  className,
  size = 'default',
  ...props
}: ContainerProps) {
  return (
    <div
      className={cn(
        'mx-auto w-full px-4 sm:px-6 lg:px-8',
        size === 'default' && 'max-w-container',
        size === 'narrow' && 'max-w-3xl',
        size === 'wide' && 'max-w-[1440px]',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}
